/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect} from "react";
import Background from "./Background";
import ConnectWallet from "./ConnectWallet";
import { useStateContext } from "../utils/web3";
import Profile from "./Profile";

const COLLECTIONS = {
  HELL: 'nonconformisthellducks',
  KEYS: 'pascal-black-market'
}

function Royalties() {
  let { isConnected, account } = useStateContext();
  const [hellDucks, setHellDucks] = useState<any>([]);
  const [keys, setKeys] = useState<any>([]);
  const [loadingHell, setLoadingHell] = useState(true);
  const [loadingKeys, setLoadingKeys] = useState(true);
  const apiKey =  '07e8f6365ba14b46b3d1c5842d9d10a0';
  const options = {
    method: 'GET',
    headers: { Accept: 'application/json', 'X-API-KEY': apiKey },
  };

  useEffect(() => {
    if (account) {
      fetchDucks(COLLECTIONS.HELL, account);
      fetchDucks(COLLECTIONS.KEYS, account);
    }
  }, [ account ]);

  const fetchDucks = async (collection:any, address:any)=> {
    let fetching = true;
    const ducks:any = [];
    let cursor:any = null;
    while(fetching) {
      const response = await fetch('https://api.opensea.io/api/v1/assets?owner=' + address + '&collection_slug='+ collection + '&limit=50' + (cursor ? ('&cursor=' + cursor) : ''), options);
      const data = await response.json();
      for (let index = 0; index < data.assets.length; index++) {
        ducks.push(data.assets[index]); 
      }
      if (data.next) {
        cursor = data.next;
      } else {
        fetching= false;
      }
    }
    switch (collection) {
      case COLLECTIONS.HELL:
        setHellDucks(ducks);
        setLoadingHell(false);
        break;
      case COLLECTIONS.KEYS:
        setKeys(ducks);
        setLoadingKeys(false);
        break;
    }
  }

  return (
    <>
      <div className="flex w-full h-5/6 z-10">
          {
            isConnected ? 
            (
              <div className="flex flex-col w-11/12 mx-auto relative h-full pb-10">
                <Profile
                  hellDucks={hellDucks}
                  keys={keys}
                  loadingHell={loadingHell}
                  loading2nd={loadingKeys}
                  setHellducks={setHellDucks}
                  setKeys={setKeys}
                />
              </div>
            )
            :
            (
              <ConnectWallet/>
            )
          }
      </div>
      <Background/>
    </>
  )
}

export default Royalties;